import React from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export const PageShell = ({ children }) => {
    return (
        <div className="min-h-screen bg-base text-text-primary">
            <Navbar />
            <main>{children}</main>
            <Footer />
        </div>
    );
};

export default PageShell;
